<!--精准读书会-->
<template>
    <div class="readd-studio_nav_content">
        <div class="head-container" v-show="showMode==='page'">
            <div class="left-head-container" @click="backReadMuseum">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
            </div>
            <div class="right-head-container"></div>
            <div class="left-head-container">
            </div>
        </div>
        <div class="readd-content-container" v-show="showMode==='page'">
            <div class="item-container">
                <div class="item-child-container">
                    <div class="read-item-one" v-for="item in itemList.slice(0,4)" :key="item" @click="pageMyjr(item)">
                        <div class="item-one-child">
                            <div class="item-month">{{item.itemMonth}}</div>
                            <div class="item-name">{{item.itemName}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-container mt-x">
                <div class="item-child-container">
                    <div class="read-item-one" v-for="item in itemList.slice(4,8)" :key="item" @click="pageMyjr(item)">
                        <div class="item-one-child">
                            <div class="item-month">{{item.itemMonth}}</div>
                            <div class="item-name">{{item.itemName}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-container mt-x">
                <div class="item-child-container">
                    <div class="read-item-one" v-for="item in itemList.slice(8,12)" :key="item" @click="pageMyjr(item)">
                        <div class="item-one-child">
                            <div class="item-month">{{item.itemMonth}}</div>
                            <div class="item-name">{{item.itemName}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-container" v-show="showMode==='detail'">
            <read-page :item-id="itemId" :item-name="itemName" :mark-info="markInfo"
                       @change-mode="changeModel" />
        </div>
    </div>
</template>
<script>
import {listItemByMuseum} from "@/api/admin/item"
import readPage from "@/components/read/readPage.vue";

export default {
    name:'bookReadingClub',
    components:{readPage},
    props:{
        museumId:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        museumId(newValue,oldValue){
            this.queryItemList();
        },
        markInfo(newValue,oldValue){
            this.queryItemList();
        },
    },
    mounted() {
    },
    created() {

    },
    data() {
        return {
            showMode:'page',
            itemList:[],
            itemId:'',
            itemName:'',
            markInfo:'pageSub',
        }
    },
    methods: {
        queryItemList(){
            listItemByMuseum({ museumKey: this.museumId }).then(res => {
                if (res.data.code === 1) {
                    this.itemList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode);
        },
        pageMyjr(item){
            this.itemId = item.itemId;
            this.itemName = item.itemName;
            this.markInfo = this.markInfo+new Date();
            this.showMode = 'detail';
            this.$emit('change-mode',this.showMode);
        },
        backReadMuseum(){
            this.$emit('back-read-museum', "homePage");
        },
    }
}
</script>
<style>
.readd-studio_nav_content{
    width: 100%;
    background-color: #fff;
    height: calc(100vh - 90px);

}
.readd-content-container{
    width: 100%;
    height: 100%;
    padding: 50px 20px 50px 20px;
    box-sizing: border-box;
}
.item-container{
    width: 100%;
    height: calc(33% - 65px);
}
.mt-x{
    margin-top: 75px;
}
.item-child-container{
    width: 100%;
    height: 100%;
    display: flex;
}
.read-item-one{
    width: calc(25% - 30px);
    height: 100%;
    background-color: #fff;
    border-radius: 4px;
    cursor: pointer;
    color: #ff7f2e;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
    margin-left: 20px;
    margin-right: 20px;
    border: 1px solid #ff7f2e;
    font-weight: bold;
    font-family: sans-serif;
    font-size: 15px;
}
.read-item-one:hover{
    background-color: #ff7f2e!important;
    color: #fff!important;
}
.item-one-child{
    width: 100%;
    height: 50px;
}
.item-month{
    width: 100%;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
.item-name{
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
}
</style>